import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import SegmentDetails from './SegmentDetails';
import moment from 'moment';
import {formatDuration} from '../common';

const TechnicalStop = ({
  segment, depAirport, arrAirport, stopDuration, translations
}) => {
  const {stopDuration: stopDurationTitle, technicalStopTitle, time} = translations;
  return (
    <Fragment>
      <div className="grid flight-stop">
        <div className="grid-item-3-4 offset-3-10 result-details-stop-info">
          <p className="text-small text-danger leading-normal">
            <i className="icon icon-t-warning-e text-small" />
            &nbsp;{technicalStopTitle}:
            <strong>{`${depAirport.name} (${depAirport.code}), ${depAirport.country}`}</strong>
          </p>
          <div className="p-2 bg-overlay-light mb-3 text-small">
            &nbsp;{stopDurationTitle}:
            <strong>{formatDuration(moment.duration(stopDuration, 'minutes'), time)}</strong>
          </div>
        </div>
      </div>
      {<SegmentDetails
        segment={segment}
        depAirport={depAirport}
        arrAirport={arrAirport}
        hasTechnicalStop={false}
        translations={translations}
      />}
    </Fragment>
  );
};

TechnicalStop.propTypes = {
  translations: PropTypes.object.isRequired,
  segment: PropTypes.object.isRequired,
  depAirport: PropTypes.object.isRequired,
  arrAirport: PropTypes.object.isRequired,
  stopDuration: PropTypes.number.isRequired
};

export default TechnicalStop;
